import { useApolloClient } from "@apollo/client";
import { useUserData } from "../../auth/useUserData.js";
import { Page, PageTopbarItem } from "../../commons/layout/Page.js";
import { PageContainer } from "../../commons/layout/PageContainer.js";
import { PageGrid } from "../../commons/layout/PageGrid.js";
import { OrganisationDetailsBox } from "../../features/organisations/boxes/OrganisationDetailsBox.js";
import { OrganisationPaymentInformationBox } from "../../features/organisations/boxes/OrganisationPaymentInformationBox.js";
import { OrganisationRegistrationDetailsBox } from "../../features/organisations/boxes/OrganisationRegistrationDetailsBox.js";
import { useOrganisationProfileQuery } from "./OrganisationProfile.generated.js";

interface Props {
  submenuItems: PageTopbarItem[];
}

export function OrganisationProfile({ submenuItems }: Props) {
  const viewer = useUserData().currentUser!;

  const client = useApolloClient();
  const query = useOrganisationProfileQuery({
    client,
  });

  const organisation = query.data?.viewer?.organisation;
  const isCraftsman = organisation?.organisationType === "CRAFTSMAN";

  return (
    <Page title={organisation?.title} submenuItems={submenuItems}>
      {organisation && (
        <PageContainer>
          <PageGrid columns={{ xs: 1, md: 2, xl: 3 }}>
            <>
              <OrganisationDetailsBox
                organisation={organisation}
                isViewerOrganisation
              />
            </>
            <>
              <OrganisationPaymentInformationBox organisation={organisation} />
              {isCraftsman && (
                <OrganisationRegistrationDetailsBox
                  organisation={organisation}
                />
              )}
            </>
          </PageGrid>
        </PageContainer>
      )}
    </Page>
  );
}
